import Button from '@ixigo/iui/Button';
import { FC } from 'react';
import { useConversation } from '../../contexts/conversation';
import { InputButtonConfig } from './index.types';

const ButtonInput: FC = () => {
    const { input, sendMessage } = useConversation();
    const config = input!.config as InputButtonConfig;

    const onClick = (button: InputButtonConfig['buttonList'][0]) => {
        const messageParts = [
            {
                isPrivate: false,
                text: {
                    content: button.name,
                },
            },
        ];

        sendMessage({ messageParts, input: button });
    };

    return (
        <div className='flex gap-10 mr-40 ml-20 flex-wrap'>
            {config.buttonList.map((item) => (
                <Button key={item.name} className='!px-20 !py-[8px]' variant='outlined' onClick={() => onClick(item)}>
                    {item.name}
                </Button>
            ))}
        </div>
    );
};

export default ButtonInput;
